import ProgramImg1 from '../../img/footer-program-img-1.png'
import ProgramImg2 from '../../img/footer-program-img-2.png'
import ProgramImg3 from '../../img/footer-program-img-3.png'
import PhoneIcon from '../../img/contact-phone-icon.png'
import MailIcon from '../../img/contact-mail-icon.png'
import FacebookIcon from '../../img/social-facebook-icon.png'
import LinkedinIcon from '../../img/social-linkedin-icon.png'
import InstagramIcon from '../../img/social-instagram-icon.png'
import YoutubeIcon from '../../img/social-youtube-icon.png'
import { NAV_LINK_CONSTANTS } from '../../Constants/NavLinksContants';

const AboutUs=[
    {
        id:1,
        aboutTxt:"Join our Community",
        aboutLink:`${NAV_LINK_CONSTANTS.PUBLIC_COMMUNITY_URL}`
    },
    {
        id:2,
        aboutTxt:"Success Stories",
        aboutLink:`${process.env.REACT_APP_FRONTEND_MAIN_URL}crack-coding-interviews/stories`
    },
    {
        id:3,
        aboutTxt:"Blogs",
        aboutLink:`${NAV_LINK_CONSTANTS.PUBLIC_BLOGS_URL}`
    },
    {
        id:4,
        aboutTxt:"Events",
        aboutLink:`${NAV_LINK_CONSTANTS.PUBLIC_EVENTS_URL}`
    },
    {
        id:5,
        aboutTxt:"Terms & Conditions",
        aboutLink:`${process.env.REACT_APP_FRONTEND_MAIN_URL}terms-and-conditions`
    },
    {
        id:6,
        aboutTxt:"Refund Policy",
        aboutLink:`${process.env.REACT_APP_FRONTEND_MAIN_URL}refund-policy`
    }
]

const PopularPrograms=[
    {
        id:1,
        programImg:ProgramImg1,
        programName:"Renaissance for Top Tech  Companies",
        programLink:`${NAV_LINK_CONSTANTS.RENAISSANCE_COURSE_URL}`
    },
    {
        id:2,
        programImg:ProgramImg2,
        programName:"Become SSE & Crack Design Rounds",
        programLink:`${NAV_LINK_CONSTANTS.LOW_LEVEL_DESIGN_COURSE_URL}`

    },
    {
        id:3,
        programImg:ProgramImg3,
        programName:"Become Java Spring Boot Backend Developer",
        programLink:`${NAV_LINK_CONSTANTS.JAVA_SPRINGBOOT_COURSE_URL}`
    },
]

const Courses=[
    {
        id:1,
        courseName:"Crack Coding Rounds in DSA",
        courseLink:`${NAV_LINK_CONSTANTS.DSA_AND_ALGORITHMS_ESSENTIALS_COURSE_URL}`
    },
    {
        id:2,
        courseName:"Python Essentials for ML & Web Dev",
        courseLink:`${NAV_LINK_CONSTANTS.BEGIN_WITH_PYTHON_COURSE_URL}`
    },
    {
        id:3,
        courseName:"Master C++ for Problem Solving & Interviews",
        courseLink:`${NAV_LINK_CONSTANTS.BEGIN_WITH_CPP_COURSE_URL}`
    },
]

const SummerTraining=[
    {
        id:1,
        courseName:"For Next Gen Builders",
        courseLink:`${NAV_LINK_CONSTANTS.AI_ENGINEERING_PAGE_URL}`
    },
]


const Businesses=[
    {
        id:1,
        courseName:"Trainings for Universities & Corporations",
        courseLink:`${NAV_LINK_CONSTANTS.BUSSINESSES_INDUSTRY_EXPERIENCE_URL}`
    },
]

const Contacts=[
    {
        id:1,
        contactIcon:PhoneIcon,
        contactTxt:"+91 9871723495",
        contactLink:"tel:+919871723495"
    },
    // {
    //     id:2,
    //     contactIcon:MapIcon,
    //     contactTxt:"1512, Iconic Corenthum Tower, Noida Sector 62, Noida.",
    //     contactLink:"https://maps.app.goo.gl/wjZXgHdkJXMDishAA"
    // },
    {
        id:2,
        contactIcon:MailIcon,
        contactTxt:"info@programmingpathshala.com",
        contactLink:"https://mail.google.com/mail/?view=cm&fs=1&to=Info@programmingpathshala.com"
    },
]

const Socials=[
    {
        id:1,
        socialIcon:FacebookIcon,
        socialLink:"https://www.facebook.com/Programmingpathshala.1"
    },
    {
        id:2,
        socialIcon:LinkedinIcon,
        socialLink:"https://www.linkedin.com/school/programming-pathshala/"
    },

    {
        id:3,
        socialIcon:InstagramIcon,
        socialLink:"https://www.instagram.com/programmingpathshala/?igsh=MWd4YzBzbWs0ZmZhdQ%3D%3D"
    },
    {
        id:4,
        socialIcon:YoutubeIcon,
        socialLink:"https://www.youtube.com/channel/UC4uPfwRHPbYlmjNMiKIdWNg"
    },
]

export {AboutUs,PopularPrograms,Courses,Contacts,Socials,SummerTraining,Businesses};